import {parseISO, compareAsc} from "date-fns";

export default {
  // Just concatenate the authorization header given the token in the state.
  authorizationHeader: (state) => {
    return `Bearer ${state.budToken}`;
  },

  /**
   * Calculate and return the WAN inbound data series.
   *
   * NOTE: Highcharts throws Error #15 if you do not sort your data by x ascending, so it is our responsibility.
   *
   * @param state
   * @returns {Array}
   */
  wanInboundUtilisationSeries: (state) => {
    let series = [];
    if (!state.links.wan.in || !state.links.wan.in.items) return series;

    if (state.links.wan.in.items.length > 0) {
      series = state.links.wan.in.items.sort((a, b) => compareAsc(parseISO(a.time), parseISO(b.time)));
      series = series.map(wud => {
        return {x: parseISO(wud.time), y: wud.value}
      });
    }
    return series;
  },

  /**
   * Calculate and return the WAN outbound data series.
   *
   * NOTE: Highcharts throws Error #15 if you do not sort your data by x ascending, so it is our responsibility.
   *
   * @param state
   * @returns {Array}
   */
  wanOutboundUtilisationSeries: (state) => {
    let series = [];
    if (!state.links.wan.out || !state.links.wan.out.items) return series;

    if (state.links.wan.out.items.length > 0) {
      series = state.links.wan.out.items.sort((a, b) => compareAsc(parseISO(a.time), parseISO(b.time)));
      series = series.map(wud => {
        return {x: parseISO(wud.time), y: wud.value}
      });
    }
    return series;
  },

  /**
   * Calculate and return the Internet inbound data series.
   *
   * NOTE: Highcharts throws Error #15 if you do not sort your data by x ascending, so it is our responsibility.
   *
   * @param state
   * @returns {Array}
   */
  internetInboundUtilisationSeries: (state) => {
    let series = [];
    if (!state.links.internet.in || !state.links.internet.in.items) return series;

    if (state.links.internet.in.items.length > 0) {
      series = state.links.internet.in.items.sort((a, b) => compareAsc(parseISO(a.time), parseISO(b.time)));
      series = series.map(wud => {
        return {x: parseISO(wud.time), y: wud.value}
      });
    }
    return series;
  },

  /**
   * Calculate and return the Internet outbound data series.
   *
   * NOTE: Highcharts throws Error #15 if you do not sort your data by x ascending, so it is our responsibility.
   *
   * @param state
   * @returns {Array}
   */
  internetOutboundUtilisationSeries: (state) => {
    let series = [];
    if (!state.links.internet.out || !state.links.internet.out.items) return series;

    if (state.links.internet.out.items.length > 0) {
      series = state.links.internet.out.items.sort((a, b) => compareAsc(parseISO(a.time), parseISO(b.time)));
      series = series.map(wud => {
        return {x: parseISO(wud.time), y: wud.value}
      });
    }
    return series;
  },

  bandwidthIntCap: (state) => {
    if (!state.links.bandwidth) {
      return '';
    }

    // This will also catch divide-by-zero as 0 is falsy in JavaScript (and NaN)
    if (!state.links.bandwidth.int_bw) {
      return '';
    }

    const intCap = state.links.bandwidth.int_bw / 1000000;
    return intCap.toFixed(1).toString();
  },

  bandwidthWanCap: (state) => {
    if (!state.links.bandwidth) {
      return '';
    }

    // This will also catch divide-by-zero as 0 is falsy in JavaScript (and NaN)
    if (!state.links.bandwidth.wan_bw) {
      return '';
    }

    const wanCap = state.links.bandwidth.wan_bw / 1000000;
    return wanCap.toFixed(1).toString();
  },
}
